import { render, staticRenderFns } from "./NotificationDialog.vue?vue&type=template&id=481d491f&scoped=true"
import script from "./NotificationDialog.vue?vue&type=script&lang=js"
export * from "./NotificationDialog.vue?vue&type=script&lang=js"
import style0 from "./NotificationDialog.vue?vue&type=style&index=0&id=481d491f&prod&scoped=true&lang=scss"
import style1 from "./NotificationDialog.vue?vue&type=style&index=1&id=481d491f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481d491f",
  null
  
)

export default component.exports